import React from "react";
import PanelGroupController from "../PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../panels/PropertiesList";

const WarehousePropertiesPanel = (props) => {

  let elements = null;
  if (!props.hasSelection) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let items = fromJS([
      {prop: "id", label: "Id", type: "string"},
      {prop: "location", label: "Location", type: "string"},
      {prop: "info.system", label: "System", type: "id"},
      {prop: "opening_time", label: "Opens", type: "time"},
      {prop: "closing_time", label: "Closes", type: "time"},
      {prop: "timezone", label: "Timezone", type: "string"},      
      {prop: "backup_warehouse_id", label: "Backup Warehouse", type: "string"},
      {prop: "reservation_status", label: "Reservations", type: "string"},
      {prop: "courier_category", label: "Courier", type: "category"},
      {prop: "courier_id", label: "Courier", type: "string"},
      {prop: "courier_account_nr", label: "Account Nr.", type: "string"}
    ])
    //
    let contact_items = fromJS([
      {prop: "contact_category", label: "Contact Details", type: "category"},
      {prop: "company_name", label: "Company or Name", type: "string"},
      {prop: "contact_name", label: "Contact Name", type: "string"},
      {prop: "contact_phone", label: "Phone", type: "telephone"},
      {prop: "contact_email", label: "Email", type: "string"},
    ])
    let address_items = fromJS([
      {prop: "address_category", label: "Address", type: "category"},
      {prop: "address.country_code", label: "Country", type: "string"},
      {prop: "address.address_line1", label: "Address Line 1", type: "string"},
      {prop: "address.address_line2", label: "Address Line 2", type: "string"},
      {prop: "address.city", label: "City", type: "string"},
      {prop: "address.state_province", label: "State / Province", type: "string"},
      {prop: "address.postcode", label: "Postcode", type: "string"}
    ])
    let properties = items.concat(contact_items).concat(address_items);
    elements = <PropertiesList properties={properties} data={props.selected} />
  }

  return (
    <PanelGroupController title="Warehouse Properties" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export default WarehousePropertiesPanel;